import { Vendor } from '../types'

export const mockVendors: Vendor[] = [
  {
    id: 'elite-extracts',
    name: 'Elite Extracts',
    website: 'https://eliteextracts.com',
    description: 'Premium 7OH and MIT extract specialist. Laboratory-grade products with detailed testing and consistent potency.',
    location: 'Denver, CO',
    founded: 2020,
    rating: 4.8,
    reviewCount: 156,
    verified: true,
    specialties: ['7OH Tablets', '7OH Extracts', 'MIT Extracts', 'Lab Testing'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'Cryptocurrency', 'Bank Transfer'],
    socialMedia: {
      reddit: 'r/eliteextracts',
      instagram: '@eliteextracts'
    }
  },
  {
    id: 'vendor-1',
    name: 'Kratom Supply Co',
    website: 'https://kratomsupplyco.com',
    description: 'Premium kratom supplier with lab-tested products and fast shipping. Known for consistent quality and excellent customer service.',
    location: 'Portland, OR',
    founded: 2018,
    rating: 4.7,
    reviewCount: 342,
    verified: true,
    specialties: ['Red Maeng Da', 'Green Borneo', '7OH Tablets'],
    shippingRegions: ['USA', 'Canada'],
    paymentMethods: ['Credit Card', 'PayPal', 'Cryptocurrency'],
    socialMedia: {
      reddit: 'r/kratomsupplyco',
      instagram: '@kratomsupplyco'
    }
  },
  {
    id: 'vendor-2', 
    name: 'Botanical Wellness',
    website: 'https://botanicalwellness.net',
    description: 'Family-owned business focusing on sustainably sourced kratom from Indonesian farmers. Offers educational resources and dosage guidance.',
    location: 'Austin, TX',
    founded: 2016,
    rating: 4.5,
    reviewCount: 187,
    verified: true,
    specialties: ['Gold Bali', 'Green Malay', 'Red Sumatra'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'Bank Transfer'],
    socialMedia: {
      facebook: 'BotanicalWellnessKratom'
    }
  },
  {
    id: 'vendor-3',
    name: 'Pure Leaf Kratom',
    website: 'https://pureleafkratom.com', 
    description: 'Specializes in small-batch, artisanal kratom products. Direct relationships with farmers ensure freshness and ethical sourcing.',
    location: 'Denver, CO',
    founded: 2020,
    rating: 4.3,
    reviewCount: 98,
    verified: false,
    specialties: ['Red Horn', 'Green Elephant', 'White Borneo'],
    shippingRegions: ['USA', 'International'],
    paymentMethods: ['Credit Card', 'Cryptocurrency', 'Money Order']
  },
  {
    id: 'vendor-4',
    name: 'Alkaloid Research Labs',
    website: 'https://alkaloidresearchlabs.com',
    description: 'Research-focused vendor with detailed alkaloid profiles and third-party testing. Caters to experienced users seeking specific potencies.',
    location: 'Seattle, WA', 
    founded: 2019,
    rating: 4.8,
    reviewCount: 156,
    verified: true,
    specialties: ['MIT Extract 60%', 'Mitragynine Extract', 'Research Grade Extracts'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'ACH Transfer'],
    socialMedia: {
      reddit: 'r/kratomresearch'
    }
  },
  {
    id: 'vendor-5',
    name: 'Green Valley Botanicals',
    website: 'https://greenvalleybotanicals.com',
    description: 'Budget-friendly option with reliable quality. Offers bulk pricing and frequent sales. Good choice for daily users.',
    location: 'Phoenix, AZ',
    founded: 2017,
    rating: 4.1,
    reviewCount: 289,
    verified: true,
    specialties: ['Bulk Powder', 'Sample Packs', 'White Strains'],
    shippingRegions: ['USA', 'Canada'],
    paymentMethods: ['Credit Card', 'PayPal']
  },
  {
    id: 'vendor-6',
    name: 'Bronx Xtracts',
    website: 'https://bronxxtracts.com',
    description: '7-OH mitragynine specialist with premium extracts and concentrates.',
    location: 'Bronx, NY',
    founded: 2022,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['7-OH Mitragynine', 'Extracts', 'Concentrates'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'Cryptocurrency'],
    contactPerson: 'Mario',
    outreachNote: 'Need to contact Mario about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-7',
    name: '7ohtabworld',
    website: 'https://7ohtabworld.com',
    description: '7-OH mitragynine tablets and specialized kratom products.',
    location: 'Unknown',
    founded: 2023,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['7-OH Tablets', '7-OH Mitragynine', 'Specialized Products'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-8',
    name: 'BKC (Bulk Kratom Capsules)',
    website: 'https://bulkkratomcapsules.com',
    description: 'Bulk kratom capsules and 7-OH mitragynine products.',
    location: 'Unknown',
    founded: 2021,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Bulk Capsules', '7-OH Mitragynine', 'Wholesale'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'ACH'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-9',
    name: 'Omega Extracts',
    website: 'https://omegaextracts.com',
    description: 'Premium kratom extracts and 7-OH mitragynine products.',
    location: 'Unknown',
    founded: 2022,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Kratom Extracts', '7-OH Mitragynine', 'Premium Products'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'Cryptocurrency'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-10',
    name: 'Divinely7',
    website: 'https://divinely7.com',
    description: '7-OH mitragynine and spiritual wellness kratom products.',
    location: 'Unknown',
    founded: 2023,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['7-OH Mitragynine', 'Spiritual Wellness', 'Premium Kratom'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-11',
    name: 'Koalaty Kratom',
    website: 'https://koalatykratom.com',
    description: 'Quality kratom products including 7-OH mitragynine options.',
    location: 'Unknown',
    founded: 2022,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Quality Kratom', '7-OH Mitragynine', 'Variety Packs'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'PayPal'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-12',
    name: 'RAW',
    website: 'https://rawkratom.com',
    description: 'Raw kratom products and 7-OH mitragynine extracts.',
    location: 'Unknown',
    founded: 2021,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Raw Kratom', '7-OH Mitragynine', 'Natural Products'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-13',
    name: '7ohblack',
    website: 'https://7ohblack.com',
    description: 'Specialized 7-OH mitragynine products and kratom extracts.',
    location: 'Unknown',
    founded: 2023,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['7-OH Mitragynine', 'Black Label Products', 'Extracts'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'Cryptocurrency'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-14',
    name: 'KratomHeads',
    website: 'https://kratomheads.com',
    description: 'Community-focused vendor with 7-OH mitragynine and traditional kratom.',
    location: 'Unknown',
    founded: 2022,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Community Focus', '7-OH Mitragynine', 'Traditional Kratom'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'PayPal'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-15',
    name: 'Powder Solutions',
    website: 'https://powdersolutions.com',
    description: 'Kratom powder solutions including 7-OH mitragynine products.',
    location: 'Unknown',
    founded: 2021,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['Powder Solutions', '7-OH Mitragynine', 'Custom Blends'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card', 'ACH'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  },
  {
    id: 'vendor-16',
    name: 'Simply7oh',
    website: 'https://simply7oh.com',
    description: 'Simple, effective 7-OH mitragynine products and kratom solutions.',
    location: 'Unknown',
    founded: 2023,
    rating: 0,
    reviewCount: 0,
    verified: false,
    specialties: ['7-OH Mitragynine', 'Pseudoindoxyl', 'Effective Products'],
    shippingRegions: ['USA'],
    paymentMethods: ['Credit Card'],
    outreachNote: 'Need to contact about platform participation - can post links regardless but want to offer chance for new releases, sales, and review responses'
  }
]